export default __webpack_public_path__ + "static/4-70872b5066803ddc5fc9266b1b856d3e.jpeg";